﻿'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:GridMultiselectController
 * @description
 * # GridMultiselectController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('GridMultiselectFilterController', ['$scope', '$rootScope', function ($scope, $rootScope) {
      var firstLoad = true;

      $scope.settings = { enableSearch: true, smartButtonMaxItems: 2 };
      $scope.names = angular.copy($scope.col.filter.filterOptions);
      $scope.selectedNames = angular.copy($scope.col.filter.filterSelectedOptions);

      $scope.open = function ($event) {
          $event.currentTarget.children[0].children[1].style.position = 'fixed';
          $event.currentTarget.children[0].children[1].style.top = '56px';
          $event.currentTarget.children[0].children[1].style.left = 'initial';
          $event.currentTarget.children[0].children[1].children[3].children[0].children[0].focus();
      };

      $scope.$watch('selectedNames', function () {
          if (firstLoad && $scope.col.filter.filterSelectedOptions.length === 0) {
              firstLoad = false;
              return;
          }

          var selectedNames = _us.pluck($scope.selectedNames, 'id');


          $scope.colFilter.listTerm = [];

          selectedNames.forEach(function (item) {
              if (!item) {
                  item = 'blank';
              }
              $scope.colFilter.listTerm.push(item);
          });

          $scope.colFilter.term = $scope.colFilter.listTerm.join(', ');
          $scope.colFilter.condition = function (searchTerm, cellValue) {
              return $scope.colFilter.listTerm.filter(function (item) { return item === 'blank' ? cellValue === null : item === cellValue; }).length > 0;
          };
          
      }, true);

      $scope.$watch(function () {
          return $rootScope.clearGridFilters;
      },
      function () {
          if ($rootScope.clearGridFilters) {
              $scope.selectedNames = [];
          }
      });

  }]);